<template>
  <v-container fluid grid-list-md>
   <v-row>
    <v-col>
        <span class="headline"> Ukupno: ({{curr1}}) : {{ localMoney(localRound(total1, 2))}} </span> <br />
        Od računa broj:  {{this.minNr}}, do računa broj: {{this.maxNr}}<br />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
              >
                <td>Rb.</td>
                <td>Sif.</td>
                <td>Artikal</td>
                <td>Kol.</td>
                <td>PDV%</td>
                <td>Uk izn.</td>
              </tr>
              <tr
                v-for="(item, index) in totItems"
                :key="item.key"
              >
                <td>{{index + 1}}.</td>
                <td>{{item.uvItem }}</td>
                <td>{{item.uvItemName }}</td>
                <td>{{item.kolicina }}</td>
                <td>{{item.uVAT }}%</td>
                <td>{{localMoney(localRound(item.Total,2))}}</td>
              </tr>
            </tbody>
          </template>
      </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn @click="documentPrintTotal()"> Isprintaj Obračun po artiklima </v-btn>
      </v-col>
    </v-row> 
    <DocumentPOSTotalItemsPrint ref="prnt" :printObj="printObj" />
 
  </v-container>
</template>

<script>
import dateFormat from '@/snippets/dateFormat'
import { moneyFormat, round, dynamicSort } from '@/snippets/allSnippets'
import DocumentPOSTotalItemsPrint from './DocumentPOSTotalItemsPrint'


export default {
  name: 'dcumentpostotal',
  props: ['items', 'period'],
  data() {
    return {
      total1: 0,
      total2: 0,
      totalFull: 0,
      totalGoods: 0,
      curr1: '',
      curr2: '',
      date: null,
      cash : 0,
      card: 0,
      other: 0,
      vat1Base: 0,
      vat1Amo: 0,
      vat2Base: 0,
      vat2Amo: 0,
      vat3Base: 0,
      vat3Amo: 0,
      noVat: 0,
      printObj: {},
      maxNr: 0,
      minNr: 1000000000,
      totItems: [],
      cardIndex: 1
    }
  },
  mounted() {
    this.minNr = 1000000000
    this.maxNr = 0
    this.curr1 = 'EUR'
    this.curr2 = 'EUR'
    if (this.items) {
      let greske = 0
      const newObj = {}
      let uvItem = ''
      let uvItemName =''
      let kolicina = 0
      let firstTime = true
      let uTotal = 0
      let uVAT = 0
      let uVatAm = 0
      let uPP = 0
      let uPPAm = 0
      let DirectDuty = 0
      let key = 0

      this.items.map(item => {
        if (item.itemID !== uvItem) {
          if (!firstTime) {
            key +=1
            const uGroup = {}
            uGroup.key = key
            uGroup.uvItem = uvItem
            uGroup.uvItemName = uvItemName
            uGroup.kolicina = kolicina
            uGroup.Total = uTotal
            uGroup.uVAT = uVAT
            uGroup.uVatAm = uVatAm
            uGroup.uPP = uPP
            uGroup.uPPAm = uPPAm
            uGroup.DirectDuty = DirectDuty
            this.totItems.push(uGroup)
          }
          uvItem = item.itemID
          uvItemName = item.itemName
          kolicina = 0
          firstTime = false
          uTotal = 0
          uVAT = 0
          uVatAm = 0
          uPP = 0
          uPPAm = 0
          DirectDuty = 0
        }
        const nrPos = parseInt(item.documentId)
        if (nrPos < this.minNr) {
          this.minNr = nrPos
        }
        if (nrPos > this.maxNr) {
          this.maxNr = nrPos
        }
        kolicina += parseFloat(item.itemPcsMinus)
        uVAT = parseFloat(item.itemVAT1Percentage)
        uVatAm += parseFloat(item.itemVAT1Amount)
        uPP = parseFloat(item.itemVAT2Percentage)
        uPPAm += parseFloat(item.itemVAT2Amount)
        DirectDuty += parseFloat(item.itemDirectDuty1)
        uTotal += item.itemFullTotal ?  parseFloat(item.itemFullTotal) : 0
        this.total1 += item.itemFullTotal ?  parseFloat(item.itemFullTotal) : 0
      })
      key +=1
      const uGroup = {}
      uGroup.key = key
      uGroup.uvItem = uvItem
      uGroup.uvItemName = uvItemName
      uGroup.kolicina = kolicina
      uGroup.Total = uTotal
      uGroup.uVAT = uVAT
      uGroup.uVatAm = uVatAm
      uGroup.uPP = uPP
      uGroup.uPPAm = uPPAm
      uGroup.DirectDuty = DirectDuty
      this.totItems.push(uGroup)
      this.totItems.sort(dynamicSort("-kolicina"))
      this.printObj.startDate = this.period.startDate ? this.period.startDate : Date.now()
      this.printObj.endDate = this.period.endDate ? this.period.endDate: Date.now()
      this.printObj.totItems = this.totItems
      this.printObj.line1 = 'Ukupno: ' + this.localMoney(this.localRound(this.total1, 2)) + ' ' + this.curr1 
      this.printObj.line2 = 'Od računa broj: ' + this.minNr + ', do računa broj:' + this.maxNr
    }
   
  },
  methods: {

    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localRound(am, dec){
      return round(am, dec)
    },
    // round (value, decimals) {
    //     return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    // },
    documentPrintTotal() {
      this.$refs.prnt.print()
    },
  },
  components: {
    DocumentPOSTotalItemsPrint
  }

}
</script>